import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCareUnit } from '../../../state/patient.selectors';

@Component({
  selector: 'wfp-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  standalone: false
})
export class LogoComponent {
  protected careUnit$ = inject(Store).select(selectCareUnit);

  protected readonly careUnitLogos = ['karolinska_logo.jpg', 'karolinska_alb_logo.jpg', 'karolinska_ccc_logo.jpg'];
  protected readonly careUnitLogoAltTexts = [
    'Karolinska Universitetssjukhuset Logga',
    'Karolinska Universitetssjukhuset Astrid Lindgrens Barnsjukhus Logga',
    'Karolinska Comprehensive Cancer Center Logga'
  ];
}
